import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/analytics';
// firebase init goes here
const config = {
  apiKey: 'AIzaSyDtAqSxnGZSGaaUy-9j2vkXPUFfm17PtGw',
  authDomain: 'auth.context.so',
  databaseURL: 'https://context-v5.firebaseio.com',
  projectId: 'context-v5',
  storageBucket: 'context-v5.appspot.com',
  messagingSenderId: '385146739042',
  appId: '1:385146739042:web:9e64e6dacfa569d5',
  measurementId: 'G-KEY9TNMP5W'
};
function initFirebase() {
  firebase.initializeApp(config);
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .enablePersistence({ synchronizeTabs: true })
      .then(resolve)
      .catch(err => {
        if (err.code === 'failed-precondition') {
          console.log('multiple tabs open, cache no go');
          reject(err);
          // Multiple tabs open, persistence can only be
          // enabled in one tab at a a time.
        } else if (err.code === 'unimplemented') {
          console.log('browser not supported, cache no go')
          reject(err);
          // The current browser does not support all of
          // the features required to enable persistence
        }
      });
    // resolve;
  });
}

// initFirebase
initFirebase().catch(error => {
  console.log('error initializing firebase', error);
});

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const providerIds = firebase.auth;
const storage = firebase.storage();
const { currentUser } = auth;
const serverTimeStamp = firebase.firestore.FieldValue.serverTimestamp;
const timestamp = firebase.firestore.Timestamp;
const array = {
  union: item => firebase.firestore.FieldValue.arrayUnion(item),
  remove: item => firebase.firestore.FieldValue.arrayRemove(item)
};
const FieldValue = firebase.firestore.FieldValue;
const firestore = firebase.firestore;
// date issue fix according to firebase
// const settings = {
//   timestampsInSnapshots: true
// };
// db.settings(settings);

// firebase collections
const usersCollection = db.collection('users');
const troubleshootingLogsCollection = db.collection('troubleshootinglogs');
const contextsCollection = db.collection('contexts');
const pagesCollection = db.collection('pages');
const userContextsLiteCollection = db.collection('userContextsLite');
const userWorkspaceLiteCollection = db.collection('userWorkspaceLite');
const invitesCollection = db.collection('invites');

const fb = {
  firebase,
  db,
  storage,
  firestore,
  providerIds,
  util: {
    serverTimeStamp,
    timestamp,
    array,
    FieldValue
  },
  auth,
  paths: {
    function: 'https://us-central1-context-v5.cloudfunctions.net/',
    functionLocal: 'http://localhost:5000/context-v5/us-central1/'
  },
  currentUser,
  usersCollection,
  troubleshootingLogsCollection,
  contextsCollection,
  pagesCollection,
  userContextsLiteCollection,
  userWorkspaceLiteCollection,
  invitesCollection
};
document.gfb = fb;
export default fb;
